import apiClient from "./config";
import { TODO_ENDPOINTS } from "./endpoints";

export const getTodos = (todo) => apiClient.get(TODO_ENDPOINTS.GET_TODOS, todo);
export const deleteTodo = (todo) => apiClient.delete(TODO_ENDPOINTS.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo) => apiClient.create(TODO_ENDPOINTS.ADD_NEW_TODO, todo);
export const updateTodo = (todo) => apiClient.put(TODO_ENDPOINTS.UPDATE_TODO, todo);

